import React, { useContext, useState, useEffect } from 'react';
import { PersonContext } from '../providers/Person.jsx';
import Quantity from '../common/Quantity.jsx';
import requests from '../utils/requests.js';
import LabeledInput from '../common/LabeledInput.jsx';
import StyledInput from '../common/StyledInput.jsx';
import functions from '../utils/functions.js';
import Login from '../login/Login.jsx';
import Autocomplete from '../common/AutocompleteAddress.jsx';
import { s } from '../Style.jsx';

const Cart = () => {

    const { authorizing, auth, user, cart, setCart, person } = useContext(PersonContext);
    const [method, setMethod] = useState("cash");
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const [checkout, setCheckout] = useState({});
    const [editingPerson, setEditingPerson] = useState({});

    const [settings, setSettings] = useState({});
    useEffect(() => {
        requests.getSettings(auth).then(settings => {
            setSettings(settings);
        });
    }, []);

    useEffect(() => {
        if (person) setEditingPerson(person);
    }, [person]);

    const [vendor, setVendor] = useState();
    const [childVendors, setChildVendors] = useState([]);
    const [selectedChildVendor, setSelectedChildVendor] = useState(null);
    useEffect(() => {
        if (!cart) return;
        if (cart.vendorId){
            setLoading(true);
            requests.getVendor(auth, { id: cart.vendorId }).then(({ vendor, childVendors }) => {
                setVendor(vendor);
                setChildVendors(childVendors);
                setSelectedChildVendor(vendor.id);
                setLoading(false);
            });
        }
    }, [cart]);

    const orderAnything = new URLSearchParams(window.location.search).get("orderAnything");
    useEffect(() => {
        if (!user) return;
        if (orderAnything === '' && cart?.items?.length > 0) {
            setCart(cart);
        }
    }, [user]);

    useEffect(() => {
        checkout.date = new Intl.DateTimeFormat('en-CA', { timeZone: "America/New_York", year: 'numeric', month: '2-digit', day: '2-digit', }).format(new Date());
        checkout.timeTo = new Date(new Date().getTime() + 60 * 60 * 1000).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: false });
        checkout.timeFrom = new Date(new Date().getTime()).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: false });
    }, []);

    const getItemPrice = (item, n) => {
        if (!vendor) return 0;
        let vendorItem = vendor.items.find(vendorItem => vendorItem.id === item.id);
        let total = vendorItem.price;
        if (typeof item.combo?.index === "number") total = vendorItem.combos[item.combo.index].price;
        item.options.forEach(option => total += vendor.items.find(vendorItem => vendorItem.id === option).price);
        total *= item.quantity * (item.combo?.quantity || 1);
        if (n) return total;
        return functions.formatMoney(total);
    };

    const getSubtotal = (n) => {
        if (orderAnything === 'yes') return n ? 0 : "0.00";
        if (!vendor) return 0;
        let total = (cart.items.reduce((acc, item) => acc + getItemPrice(item, 1), 0));
        if (n) return total;
        return functions.formatMoney(total);
    };

    const getSubtotalTax = (n) => {
        if (!vendor) return 0;
        let total = (getSubtotal(1) * (settings.taxRate || .13));
        if (n) return total;
        return functions.formatMoney(total);
    };

    const getDeliveryFee = (n) => {
        let total = ((settings.deliveryFee || 10));
        if (vendor) total = ((vendor.deliveryFee || 10));
        if (n) return total;
        return functions.formatMoney(total);
    };

    const getDeliveryFeeTax = (n) => {
        if (!vendor) return 0;
        let total = ((settings.taxRate || .13) * (getDeliveryFee(1)));
        if (n) return total;
        return functions.formatMoney(total);
    };

    const getTotal = (n) => {
        let total = (getSubtotal(true) + getSubtotalTax(true) + getDeliveryFee(1) + getDeliveryFeeTax(1));
        if (n) return total;
        return functions.formatMoney(total);
    };

    return <>
        <div style={{ ...s.headerBox, marginBottom: 20 }}>
            <div style={s.headerInnerBox}>

                {orderAnything === '' && <>
                    <h1 style={{ marginBottom: 0 }}>Order Anything</h1>
                    <span style={{ fontSize: 14 }}>And thank you for choosing The Versatile Express!</span>
                </>}
                {orderAnything !== '' && <>
                    <h1 style={{ marginBottom: 0 }}>Cart</h1>
                    <span style={{ fontSize: 14 }}>Review your current order</span>
                </>}

            </div>
        </div>
        <div style={s.paddingContainer}>
            <div style={s.mobileContainer}>

                {(loading || authorizing) && <i className={"fas fa-spinner fa-spin"}></i>}

                {!loading && !authorizing && <>

                    {!user && <div style={{ marginTop: 40 }}>
                        <Login componentOnly title="Let's start with your phone number." />
                    </div>}

                    {user && <>

                        {orderAnything !== '' && !cart?.items?.length && <p>No items in cart.</p>}

                        {orderAnything !== '' && !!cart?.items?.length && <>

                            <h3 style={{ marginBottom: 10 }}>{vendor?.name}</h3>

                            {childVendors.length > 0 && <div style={{ marginBottom: 10 }}>
                                <div style={{ ...s.rowCenter, marginTop: 10 }}>
                                    <span style={{ fontSize: 14, fontWeight: "bold" }}>Pickup Location</span>
                                    <select 
                                        value={selectedChildVendor} disabled={!vendor} name="childVendor" id="childVendor"
                                    style={{ width: "50%", height: 30, padding: 10, borderRadius: 5, border: "1px solid #ccc" }} onChange={e => {
                                        setCart({ ...cart, vendorId: e.target.value });
                                        setSelectedChildVendor(e.target.value);
                                        setLoading(true);
                                    }}>
                                        <option value="">Select Location</option>
                                        <option value={vendor.id}>{vendor.address}</option>
                                        {childVendors.map((childVendor, i) => <option key={i} value={childVendor.id}>{childVendor.address}</option>)}
                                    </select>
                                </div>

                            </div>}

                            {!!cart?.items?.length && <div style={s.box}>
                                <div style={{ ...s.table, marginBottom: 0 }}>
                                    {cart.items.map((item, i) => <div style={s.cell(i)} key={i}>
                                        <div style={{ width: "100%", padding: "0 10px 4px" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: 10, justifyContent: "flex-end", width: "100%" }}>
                                                <s.ExitArrow does={() => setCart({ ...cart, items: cart.items.filter((cartItem, j) => i !== j) })} />
                                                <span style={{ flex: 1, fontSize: 16 }}>{vendor?.items.find(i => i.id === item.id)?.name}</span>
                                                <div>
                                                    <Quantity value={item.quantity} onChange={e => setCart({ ...cart, items: cart.items.map((cartItem, j) => i === j ? { ...cartItem, quantity: e } : cartItem) })} />
                                                </div>
                                                <span style={{ width: 60, fontWeight: "bold", textAlign: "right" }}>${getItemPrice(item)}</span>
                                            </div>
                                            {(!!item.combo?.items?.length || !!item.options?.length) && <div style={{ margin: "10px 0 0" }}>
                                                <div>
                                                    {item.combo && item.combo.items.map((comboItem, j) => <div style={{ width: "100%", textAlign: "right" }} key={j}>
                                                        <span style={{ fontSize: 14 }}>{vendor?.items.find(i => i.id === comboItem)?.name}</span>
                                                    </div>)}
                                                </div>
                                                <div>
                                                    {item.options && item.options.map((option, j) => <div style={{ width: "100%", textAlign: "right" }} key={j}>
                                                        <span style={{ fontSize: 14 }}>{vendor?.items.find(i => i.id === option)?.name}</span>
                                                    </div>)}
                                                </div>
                                            </div>}
                                            {item.notes && <span style={{ boxShadow: "inset 0 10px 4px -10px #00000050", borderTop: "1px solid #00000050", paddingTop: 10, margin: "10px 0 6px", display: "block", fontSize: 14 }}>{item.notes}</span>}
                                        </div>
                                    </div>)}
                                </div>
                            </div>}

                        </>}

                        {orderAnything === '' && <>
                            <h3 style={{ marginBottom: 10 }}>Pickup Address</h3>
                            <Autocomplete width={"100%"} value={checkout?.pickup} onChange={e => setCheckout({ ...checkout, pickup: e })} />

                            <h3 style={{ marginBottom: 10 }}>What do you need?</h3>
                            <LabeledInput style={{ width: "100%", height: 140, boxSizing: "border-box" }} disabled={!user} type="textarea"
                                placeholder={"Grab me a 4L of 2%, and the cheapest cat litter they have. Thanks!"} value={checkout?.notes}
                                onChange={e => setCheckout({ ...checkout, notes: e })} />
                        </>}

                        {orderAnything !== '' && cart?.items?.length > 0 && <>

                            <h3 style={{ marginBottom: 10 }}>Order Summary</h3>
                            <div style={s.box}>
                                <div style={{ ...s.table, marginBottom: 0 }}>
                                    <div style={s.cell(0)}>
                                        <span style={{ fontSize: 14 }}>Subtotal</span>
                                        <span style={{ fontSize: 14 }}>${getSubtotal()}</span>
                                    </div>
                                    <div style={s.cell(1)}>
                                        <span style={{ fontSize: 14 }}>Delivery Fee</span>
                                        <span style={{ fontSize: 14 }}>${getDeliveryFee()}</span>
                                    </div>
                                    <div style={s.cell(0)}>
                                        <span style={{ fontSize: 14 }}>Tax</span>
                                        <span style={{ fontSize: 14 }}>${(getDeliveryFeeTax(1) + getSubtotalTax(1)).toFixed(2)}</span>
                                    </div>
                                    <div style={s.cell(1)}>
                                        <span style={{ fontSize: 14 }}>Total</span>
                                        <h3 style={{ margin: "10px 0", fontSize: 18 }}>${getTotal()}</h3>
                                    </div>
                                </div>
                            </div>
                        </>}

                        {(orderAnything === '' || cart?.items?.length > 0) && <>
                            <h3 style={{ marginBottom: 20 }}>Delivery Details</h3>
                            <div style={{}}>
                                <div style={{ marginBottom: 10 }}>
                                    <div style={{ ...s.rowCenter, marginTop: 10 }}>
                                        <span style={{ fontSize: 14, fontWeight: "bold" }}>Phone Number</span>
                                        <span style={{ fontSize: 14 }}>{functions.formatPhone(user?.phoneNumber)}</span>
                                    </div>
                                    <div style={{ ...s.rowCenter, marginTop: 10 }}>
                                        <span style={{ fontSize: 14, fontWeight: "bold" }}>Delivery Address</span>
                                        <Autocomplete style={{ margin: 0 }} width={"50%"} value={editingPerson?.address} onChange={e => setEditingPerson({ ...editingPerson, address: e })} />
                                    </div>
                                </div>
                            </div>
                        </>}

                        {(orderAnything !== '' && cart?.items?.length > 0) && <>
                            <StyledInput label="Notes" type="textarea" placeholder={"Delivery instructions..."} value={checkout?.notes} onChange={e => setCheckout({ ...checkout, notes: e })} />
                        </>}

                        {/* {(cart?.items?.length > 0 || orderAnything === '') && <>
                            <h3 style={{ marginBottom: 0 }}>Delivery Window</h3>
                            <div>
                                <LabeledInput boxstyle={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} labelstyle={{ fontSize: 14, flex: 1 }} inputstyle={{ padding: 10, margin: 10, flex: 3 }} label="Deliver on" type="date" onChange={e => setCheckout({ ...checkout, date: e })} value={checkout.date} />
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 0, justifyContent: "space-between" }}>
                                <LabeledInput boxstyle={{ display: "flex", justifyContent: "space-between", alignItems: "center", flex: 1 }} labelstyle={{ fontSize: 14, flex: 1 }} inputstyle={{ padding: 10, margin: 10, flex: 1 }} label="Between" type="time" value={checkout.timeTo} onChange={e => setCheckout({ ...checkout, timeTo: e })} />
                                <LabeledInput boxstyle={{ display: "flex", justifyContent: "space-between", alignItems: "center", flex: 1 }} labelstyle={{ fontSize: 14, flex: 1 }} inputstyle={{ padding: 10, margin: 10, flex: 1 }} label="and" type="time" value={checkout.timeTo} onChange={e => setCheckout({ ...checkout, timeTo: e })} />
                            </div>
                        </>} */}


                        {(orderAnything === '' || (functions.checkHours(vendor?.hours, vendor?.timezone, checkout?.date, checkout?.timeTo) && !!cart?.items?.length))

                            && <>

                                <h3 style={{ marginBottom: 10 }}>Payment Details</h3>
                                {orderAnything === '' && <>
                                    <div style={{ marginTop: 10, border: "1px solid #ccc", padding: 10, borderRadius: 5, textAlign: "right" }}>
                                        <div><span style={{ fontSize: 14 }}>Delivery Fee: $10.00</span></div>
                                        <div><span style={{ fontSize: 14 }}>Tax: $1.30</span></div>
                                        <h5 style={{ margin: "10px 0 4px 0", fontSize: 18 }}>Total: $11.30</h5>
                                    </div>
                                </>}

                                <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                                    <button
                                        style={{ backgroundColor: method === 'cash' ? "#f0f0f0" : "white", padding: "10px 20px", borderRadius: 5, border: "1px solid #ccc" }}
                                        onClick={() => setMethod('cash')}>Cash</button>
                                    {/* <button
                                        style={{ backgroundColor: method === 'debit' ? "#f0f0f0" : "white", padding: "10px 20px", borderRadius: 5, border: "1px solid #ccc" }}
                                        onClick={() => setMethod('debit')}>Debit</button> */}
                                    <button
                                        style={{ backgroundColor: method === 'stripe' ? "#f0f0f0" : "white", padding: "10px 20px", borderRadius: 5, border: "1px solid #ccc" }}
                                        onClick={() => setMethod('stripe')}>Pay Online</button>
                                </div>

                                <div style={{ marginTop: 20, display: "flex", flexDirection: "column", gap: 10 }}>
                                    {method === 'stripe' && <>
                                        <span style={{ fontSize: 14, marginBottom: -4 }}>Your total will be confirmed after placing the order</span>
                                        <span style={{ fontSize: 14, fontWeight: "bold" }}>You will be notified shortly after ordering with a request for payment.</span>
                                    </>}
                                    {/* {method === 'debit' && <>
                                        <span style={{ fontSize: 14, marginBottom: -4 }}>Your total will be confirmed after placing the order</span>
                                        <span style={{ fontSize: 14, fontWeight: "bold" }}>Thanks! Our driver will bring a debit machine with him.</span>
                                    </>} */}

                                    {method === 'cash' && <>
                                        <span style={{ fontSize: 14, marginBottom: -4 }}>Your total will be confirmed after placing the order</span>
                                        <span style={{ fontSize: 14, fontWeight: "bold" }}>Our drivers accept cash at the door!</span>
                                    </>}
                                </div>

                                <div style={{ marginTop: 20, display: "flex", flexDirection: "column", gap: 10 }}>
                                    {(() => {

                                        let warnstyle = { fontSize: 16, textAlign: "center", marginTop: 10, color: "rgb(118, 0, 0)" };

                                        if (!method) return <span style={warnstyle}>Please select a payment method.</span>;
                                        if (!editingPerson.address && !person.address) return <span style={warnstyle}>Please enter a delivery address.</span>;
                                        if (orderAnything === '' && !checkout?.pickup) return <span style={warnstyle}>Please enter a pickup address.</span>;
                                        if (orderAnything === '' && !checkout?.notes) return <span style={warnstyle}>Please enter a description of what you need.</span>;
                                        if (childVendors.length && !selectedChildVendor) return <span style={warnstyle}>Please select a pickup location.</span>;
                                        //todo - block if closed (parent hours only)

                                        return <button
                                            style={{ backgroundColor: "#f0f0f0", padding: "10px 20px", borderRadius: 5, border: "1px solid #ccc" }}
                                            onClick={async () => {
                                                setLoading("Placing Order...");

                                                await requests.updatePerson(auth, { ...editingPerson, address: editingPerson.address });

                                                const order = await requests.createOrder(auth, {

                                                    items: orderAnything === '' ? undefined : cart?.items?.map(cartItem => ({ ...cartItem, total: getItemPrice(cartItem, 1), })) || [],
                                                    address: editingPerson.address || person.address || "",
                                                    type: orderAnything === '' ? "orderAnything" : "cart",
                                                    vendorId: orderAnything === '' ? undefined : cart.vendorId || "",
                                                    notes: checkout.notes || "",
                                                    customerPhone: user.phoneNumber || "",
                                                    customerId: user.uid || "",
                                                    pickup: checkout.pickup || "",
                                                    method,
                                                    date: checkout.date || new Intl.DateTimeFormat('en-CA', { timeZone: "America/New_York", year: 'numeric', month: '2-digit', day: '2-digit', }).format(new Date()),
                                                    timeFrom: checkout.timeFrom || "",
                                                    timeTo: checkout.timeTo || "",

                                                });
                                                console.log("created", { order });
                                                if (!order.success) {
                                                    setLoading(false);
                                                    setError(order.reason);
                                                    return;
                                                }
                                                window.location.href = '/orders';
                                            }}>Place Order</button>;

                                    })()}
                                </div>

                            </>}

                        {!!cart?.vendorId && !functions.checkHours(vendor?.hours, vendor?.timezone, checkout?.date, checkout?.timeTo) && <>
                            <div>
                                <span>This business is closed at the chosen delivery time.</span>
                            </div>
                        </>}

                    </>}
                </>}
            </div>
        </div>
    </>;
}
export default Cart;